import { validator } from '../../utils';
var getInvalidStringRegEx = function (base, names, substring, isName) {
    var normalized = isName ? base.filter(function (s) { return !names.includes(s); }) : base;
    var baseRegexString = "\\b" + normalized.join('\\b|\\b') + "\\b";
    var regexString = substring.length
        ? baseRegexString + "|" + substring.join('|')
        : baseRegexString;
    return new RegExp(regexString, 'gi');
};
export var HasNoBadWords = function (isName) {
    return function validate(value, _a) {
        var _b = _a.badWords, base = _b.base, names = _b.names, substring = _b.substring;
        if (!base.length || !value) {
            return true;
        }
        var invalidStringRegex = getInvalidStringRegEx(base, names, substring, isName);
        var normalizedValue = String(value)
            .replace(/[\s_]+/g, ' ')
            .replace(/^\s|\s$/g, '');
        var isValid = !normalizedValue.match(invalidStringRegex);
        return isValid;
    };
};
export var BadWordsErrorMessage = 'We’ve flagged one of the words you used in your response as abusive language. Try again without that word.';
export var HasNoBadWordsValidator = function (isName) {
    return validator(HasNoBadWords(isName), BadWordsErrorMessage);
};
//# sourceMappingURL=HasNoBadWords.js.map